import React from "react";
import BackButton from "../BackButton/BackButton";
import { Typography } from "@material-ui/core";

const PageHeader = ({ hasBack = true, title, onBack, subtitle }) => {
  return (
    <div className="flex items-start gap-6">
      {hasBack ? <BackButton onClick={onBack} /> : null}
      <div>
        <Typography
          style={{ fontSize: "20px", display: "inlineblock" }}
          variant="subtitle2"
        >
          {title}
        </Typography>
        {subtitle ? (
          <span className="text-14 text-gray-500">{subtitle}</span>
        ) : null}
      </div>
    </div>
  );
};

export default PageHeader;
